// @ts-ignore
import { set } from 'lodash'
import axios from 'axios'
// @ts-ignore
import { downloadBinaryFile, Base64 } from "@/helpers"

export default {
    namespaced: true,
    state: {
        loading: false,
        upload: false,
        checkedInn: '',
        list: [],
        exactlyMarkers: [],
        user: '',
        history: [],
        pagination: {}
    },
    mutations: {
        setStateObject(state: any, { name, value }) {
            set(state, name, value)
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setUpload(state, upload) {
            state.upload = upload
        }
    },
    actions: {
        getData({commit} , {name, surname, patronymic, birthday, serial, number, inn}) {
            commit('setLoading', true)
            commit('setUpload', false)

            return axios({
                baseURL: process.env.API_FL,
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                data: {
                    method: 'online_fl',
                    data: {
                        action: 'getData',    
                        name,
                        surname,
                        patronymic,
                        birthday,
                        serial,
                        number,
                        inn,
                    },
                    // @ts-ignore
                    auth:{
                        sid: window.apiSession
                    },
                }
            }).then(e => {
                
                if(e?.data?.auth?.code !== 0) {
                    switch(e?.data?.auth?.code){
                        case 9:
                            this.dispatch("showErrorPopUp", 'Превышен лимит запросов', { root: true })
                            break
                        default:
                            this.dispatch("showErrorPopUp", 'Ошибка авторизации: ' + e.data.auth.message, { root: true })
                            break       
                    }
                    commit('setLoading', false)
                    commit('setStateObject', { name: 'list', value: [] })
                }
                if(e?.data?.message !== "successfully") {
                    this.$store.dispatch("showErrorPopUp", e.data.message, { root: true })
                }
                if(e?.data?.data && Object.values(e?.data?.data)?.length) {
                    commit('setStateObject', { name: 'list', value: e.data.data })
                    if(e?.data?.check_inn?.data?.inn) {
                        commit('setStateObject', { name: 'checkedInn', value: e?.data?.data?.check_inn?.data?.inn })
                    }
                    commit('setUpload', true)
                } else if(e.statusText === 'error' || e.status !== 200 || e.data.status === 'error') {
                    commit('setLoading', false)
                    this.$store.dispatch("showErrorPopUp", `Превышено время ожидания, попробуйте позже или обратитесь в службу технической поддержки.`, { root: true })
                } else {
                    commit('setLoading', false)
                    commit('setStateObject', { name: 'list', value: [] })
                }
                return e?.data?.data
            }).catch((error) => {
                console.log(error.message)
                commit('setLoading', false)
            })
        },
        getAllowed({ commit}, allowedList) {
            return axios({
                baseURL: process.env.API_FL,
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                data: {
                    method: 'online_fl',
                    data: {
                        list: allowedList,
                        action: 'getAllowedModules' 
                    },
                    auth: {
                        sid: window.apiSession
                    }
                }
            }).then(e => {
                if(e.data.data) {
                    commit('setStateObject', { name: 'exactlyMarkers', value: e.data.data })
                } else {
                    commit('setStateObject', { name: 'exactlyMarkers', value: [] })
                }
                return e?.data
            }).catch(error => {
                console.log(error)
            })
        },
        getHistory({commit},{offset = 0,limit = 50, searchQuery, users, date_from, date_to, show_adm}) {
            axios({
                baseURL: process.env.API_FL,
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                data: {
                    method:'online_fl',
                    data:{
                        action: 'getHistory',
                        offset,
                        limit,
                        filterUsers: users,
                        search: searchQuery,
                        dateFrom: date_from,
                        dateTo: date_to,
                        show_adm
                    },
                    // @ts-ignore
                    auth: {
                        sid: window.apiSession
                    }
                }
            }).then(e => {        
                commit('setStateObject', { name: 'history', value: e?.data?.data?.history ?? []})
                commit('setStateObject', { name: 'pagination', value: e?.data?.data?.pagination })
                //commit('setStateObject', { name: 'user', value: e?.data?.history?.userName })
            })
        },
        getPdf({ dispatch, commit }, {imgHtmlCode, filename}) {
            return dispatch('RomAPI', {
                method: 'save_file',
                data: {
                    format: "pdf",
                    html: Base64.encode(imgHtmlCode),
                    landscape: false,
                    out_name: filename,
                    save_to_history: false,
                    source: process.env.PRODUCT_CODE,
                    target: "fl_report"
                },
                responseType: 'arraybuffer'
            }, {root : true}).then(res => {
                downloadBinaryFile(res.data, filename)
            }).finally(() => {
                commit('setUpload', false)
                commit('setLoading', false)
                dispatch('getHistory', {
                    offset: 0, 
                    limit: 50, 
                    searchQuery: '', 
                    users: [], 
                    date_from: '', 
                    date_to: '', 
                    show_adm: true
                })
            })
        }
    }
}
